import { c as _c } from "react/compiler-runtime";
import { buttonVariants } from '@/components/ui/Button';
import { cn } from '@/lib/utils';
import { ChevronLeft, ChevronRight } from '@/components/ui/icons/Icons';
import { DateRange, DayPicker, Matcher } from 'react-day-picker';
type CalendarProps = {
  className?: string;
  classNames?: Record<string, string>;
  showOutsideDays?: boolean;
  selected?: DateRange;
  onSelect?: (date: DateRange | undefined) => void;
  mode?: 'range';
  defaultMonth?: Date;
  month?: Date;
  onMonthChange?: (month: Date) => void;
  autoFocus?: boolean;
  numberOfMonths?: number;
  disabled?: Matcher | Matcher[];
  onDayClick?: (day: Date) => void;
};
const Calendar = t0 => {
  const $ = _c(40);
  let autoFocus;
  let className;
  let classNames;
  let defaultMonth;
  let disabled;
  let month;
  let numberOfMonths;
  let onDayClick;
  let onMonthChange;
  let onSelect;
  let props;
  let selected;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      classNames,
      showOutsideDays: t1,
      selected,
      onSelect,
      mode: t2,
      defaultMonth,
      month,
      onMonthChange,
      autoFocus,
      numberOfMonths,
      disabled,
      onDayClick,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = autoFocus;
    $[2] = className;
    $[3] = classNames;
    $[4] = defaultMonth;
    $[5] = disabled;
    $[6] = month;
    $[7] = numberOfMonths;
    $[8] = onDayClick;
    $[9] = onMonthChange;
    $[10] = onSelect;
    $[11] = props;
    $[12] = selected;
    $[13] = t1;
    $[14] = t2;
  } else {
    autoFocus = $[1];
    className = $[2];
    classNames = $[3];
    defaultMonth = $[4];
    disabled = $[5];
    month = $[6];
    numberOfMonths = $[7];
    onDayClick = $[8];
    onMonthChange = $[9];
    onSelect = $[10];
    props = $[11];
    selected = $[12];
    t1 = $[13];
    t2 = $[14];
  }
  const showOutsideDays = t1 === undefined ? true : t1;
  const mode = t2 === undefined ? "range" : t2;
  let t3;
  if ($[15] !== onDayClick) {
    t3 = day => {
      onDayClick?.(day);
    };
    $[15] = onDayClick;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  const handleDayClick = t3;
  let t4;
  if ($[17] !== className) {
    t4 = cn("p-3", className);
    $[17] = className;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  let t6;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cn(buttonVariants({
      variant: "outline"
    }), "size-7 bg-transparent p-0 opacity-50 hover:opacity-100 absolute left-1");
    t6 = cn(buttonVariants({
      variant: "outline"
    }), "size-7 bg-transparent p-0 opacity-50 hover:opacity-100 absolute right-1");
    $[19] = t5;
    $[20] = t6;
  } else {
    t5 = $[19];
    t6 = $[20];
  }
  let t7;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = cn(buttonVariants({
      variant: "ghost"
    }), "size-8 p-0 font-normal aria-selected:opacity-100");
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== classNames) {
    t8 = {
      months: "flex flex-col sm:flex-row gap-4 relative",
      month: "space-y-4",
      month_caption: "flex justify-center pt-1 relative items-center h-7",
      caption_label: "text-sm font-medium",
      nav: "absolute inset-x-0 top-0 flex items-center justify-between px-1 z-10 h-7 pt-1",
      button_previous: t5,
      button_next: t6,
      month_grid: "w-full border-collapse space-y-1",
      weekdays: "flex",
      weekday: "text-muted-foreground rounded-md w-8 font-normal text-[0.8rem]",
      week: "flex w-full mt-2",
      day: "relative p-0 text-center text-sm",
      day_button: t7,
      range_start: "day-range-start rounded-l-md [&>button:hover]:bg-primary [&>button:hover]:text-white",
      range_end: "day-range-end rounded-r-md [&>button:hover]:bg-primary [&>button:hover]:text-white",
      range_middle: "aria-selected:bg-accent aria-selected:text-accent-foreground",
      selected: "bg-primary text-primary-foreground hover:bg-primary hover:text-white focus:bg-primary focus:text-primary-foreground",
      outside: "day-outside text-muted-foreground aria-selected:bg-accent/50 aria-selected:text-muted-foreground",
      disabled: "text-muted-foreground opacity-50",
      hidden: "invisible",
      ...classNames
    };
    $[22] = classNames;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      Chevron: _temp
    };
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== autoFocus || $[26] !== defaultMonth || $[27] !== disabled || $[28] !== handleDayClick || $[29] !== mode || $[30] !== month || $[31] !== numberOfMonths || $[32] !== onMonthChange || $[33] !== onSelect || $[34] !== props || $[35] !== selected || $[36] !== showOutsideDays || $[37] !== t4 || $[38] !== t8) {
    t10 = <DayPicker mode={mode} showOutsideDays={showOutsideDays} selected={selected} onSelect={onSelect} defaultMonth={defaultMonth} month={month} onMonthChange={onMonthChange} autoFocus={autoFocus} numberOfMonths={numberOfMonths} disabled={disabled} onDayClick={handleDayClick} weekStartsOn={1} className={t4} classNames={t8} components={t9} {...props} />;
    $[25] = autoFocus;
    $[26] = defaultMonth;
    $[27] = disabled;
    $[28] = handleDayClick;
    $[29] = mode;
    $[30] = month;
    $[31] = numberOfMonths;
    $[32] = onMonthChange;
    $[33] = onSelect;
    $[34] = props;
    $[35] = selected;
    $[36] = showOutsideDays;
    $[37] = t4;
    $[38] = t8;
    $[39] = t10;
  } else {
    t10 = $[39];
  }
  return t10;
};
Calendar.displayName = 'Calendar';
export { Calendar };
export type { CalendarProps };
function _temp(t0) {
  const {
    orientation,
    ...props_0
  } = t0;
  return orientation === "left" ? <ChevronLeft className="size-4" {...props_0} /> : <ChevronRight className="size-4" {...props_0} />;
}